"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var usePrevious = function usePrevious(state) {
  var ref = react_1.useRef();
  react_1.useEffect(function () {
    ref.current = state;
  });
  return ref.current;
};

exports["default"] = usePrevious;